import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { BillingOrder } from 'src/app/models/billingorder.model';
import { ApplicationType, LeaseType, ProgramType, ProgramTypeReviewStatus, SelectType } from 'src/app/models/constants';
import { CodeAndHash, Lease } from 'src/app/models/lease.model';
import { TableColumn } from 'src/app/models/table-columns';
import { ShortCodeListItem, ShortCodesService, UpdatePricingArgs } from 'src/app/services/shortcodes.service';
import { OrderTransaction, PendingOrderService, HashCode } from 'src/app/services/pendingorder.service';
import { TermLengthPipe } from '../../../../shared/table-data.pipe';
import { ConfirmationService } from 'primeng/api';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { AccountService } from 'src/app/services/account.service';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ConfigService } from 'src/app/services/config.service';
import { DiscountSummary } from 'src/app/models/discount.model';
import { ShortCodesRole, OrderTransactionType } from 'src/app/models/constants';
import { chunk } from 'lodash-es';
import { RouterService, ScrAuthenticationService } from 'src/app/services';
import { Account } from '../../../../models/account.model';
import { MessageCode } from '../../../../shared/messages/messages.component';
import { IncomingState } from '../order-short-code.component';
import { MultiStateButtonChangeEvent } from '../../../custom-controls/multi-state-button/multi-state-button.component';

export enum MessageLocation {
  TopOfPage = "TopOfPage",
  CartTabSection = "CartTabSection",
  SelectCodeSection = "SelectCodeSection",
  MemorableCodeSection = "MemorableCodeSection"
}

interface ComponentUpdatePricingArgs extends UpdatePricingArgs {
  completionMessage?: string;
  completionArgs?: object;
  messageLocation?: MessageLocation;

  /**
   * If true, do not clear existing messages.
   */
  preserveExistingMessages?: boolean;

  /**
   * True if this is user initiated.
   */
  userInitiatedUpdate?: boolean;


  /**
   * Should we emit a GA add to cart.
   */
  emitGaEventForScId?: number;


  /**
   * Should we emit a view cart.
   */
  emitGaViewCartEvent?: boolean;
}


export class SyncObj {
  additionalSelectCodes: number[] = [];
  additionalRandomCodes: number | CodeAndHash[] = [];
  pendingOrder: BillingOrder = new BillingOrder();
}

interface PagingInfoItem {
  name: string;
  value: Lease;
  additionalName?: string;
}
interface PagingInfo {
  location: string;
  pageNumber: number;
  numberOfPages: number;
  pageContent: PagingInfoItem[][];
}


type SimilarCodeOption = Record<string, unknown> & {
  name: string;
  value: Lease;
};


@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent extends ScrBaseComponent implements OnInit, OnDestroy {

  CognitoGroup: typeof ShortCodesRole = ShortCodesRole;
  public pendingOrder = new BillingOrder();
  public randomCodesToGen = 1;
  public selectCodeSearch = '';
  public monthlyBilling?: boolean; //for new
  public renew = false;
  public bulk = false;
  public needsactionRenew = false;
  public nextMonthlyBillDate = '10/01/2021'; //temp holder for now
  public tableColumn: TableColumn[] = [];
  termLength: TermLengthPipe = new TermLengthPipe();
  private account!: Account;

  memorableOptions = [
    { label: 'Easy to Remember 6', value: 'easyNumbers6' },
    { label: 'Easy to Remember 5', value: 'easyNumbers5' },
    { label: 'Cool Names', value: 'coolNames' },
    { label: '4 Identical Numbers', value: 'fourIdenticalNumbers' },
    { label: 'Sequential Numbers', value: 'fourSequentialNumbers' },
    { label: 'Repeating Pairs', value: 'repeatingPairs' },
    { label: 'Range of Short Codes', value: 'range' }
  ];
  public tableColumnWithoutDiscounts: TableColumn[] = [
    { field: 'include', width: '2' },
    { field: 'scId', width: '4' },
    { field: 'shortCodeType', width: '3' },
    { field: 'term', width: '5' },
    { field: 'listPrice', width: '4' },
    { field: 'price', width: '6' },
    { field: 'delete', header: '', width: '2' }
  ];
  public tableColumnWithDiscounts: TableColumn[] = [
    { field: 'include', width: '2' },
    { field: 'scId', width: '4' },
    { field: 'shortCodeType', width: '3' },
    { field: 'term', width: '5' },
    { field: 'listPrice', width: '4' },
    { field: 'discount', width: '7' },
    { field: 'price', width: '4' },
    { field: 'delete', header: '', width: '2' }
  ];

  public tableColumnWithoutDiscountsRenew: TableColumn[] = [
    { field: 'scId', width: '4' },
    { field: 'shortCodeType', width: '3' },
    { field: 'term', width: '5' },
    { field: 'listPrice', width: '4' },
    { field: 'price', width: '6' },
  ];
  public tableColumnWithDiscountsRenew: TableColumn[] = [
    { field: 'scId', width: '4' },
    { field: 'shortCodeType', width: '3' },
    { field: 'term', width: '5' },
    { field: 'listPrice', width: '4' },
    { field: 'discount', width: '7' },
    { field: 'price', width: '4' },
  ];
  public termOptions = [
    { label: '3-Month', value: 3 },
    { label: '6-Month', value: 6 },
    { label: '12-Month', value: 12 },
  ];

  public termOptionsForMB = [
    { label: '3-Month', value: 3 },
    { label: '6-Month', value: 6 },
    { label: '12-Month', value: 12 },
    { label: 'Billed Monthly', value: 14 },
  ];

  
  public similarCodeOptions: SimilarCodeOption[] = [];
  public memorableCodeChoice?: string;
  public codeAvailable = false;
  public selectSearched = false;
  public wildCardPaging: PagingInfo = {
    location: 'WildcardSearch',
    pageNumber: 0,
    numberOfPages: 0,
    pageContent: []
  };
  public memorableCodePaging: PagingInfo = {
    location: 'MemorableCode',
    pageNumber: 0,
    numberOfPages: 0,
    pageContent: []
  };
  public NUM_OF_SIMILARS_TO_RETURN = 8;
  public shortCodeRange: { fromRange: string, toRange: string } = { fromRange: '', toRange: '' };
  selectedIndex: number | undefined;
  easyNumbers = [{ name: '2' }, { name: '3' }, { name: '4' }, { name: '5' }, { name: '6' }, { name: '7' }, { name: '8' }, { name: '9' }];
  coolNameFilters = [{ name: 'A-D' }, { name: 'E-H' }, { name: 'I-L' }, { name: 'M-Q' }, { name: 'R-U' }, { name: 'V-Z' }];


  @ViewChild(ConfirmDialog, { static: false }) confirmDialog!: ConfirmDialog;
  @ViewChild('shortCodeSearchForm', { static: false }) shortCodeSearchForm!: NgForm;
  @ViewChild('memorableCodeRangeForm', { static: false }) memorableCodeRangeForm!: NgForm;
  @ViewChild('promoCodeEr', { static: false }) promoCodeEr!: ElementRef;

  promoCode?: string;

  cartTabMessage: string | undefined;
  selectCodeMessage: string | undefined;
  selectCodeMessageSeverity = 'error';
  memorableCodeMessage: string | undefined;
  randomCodeMessage: string | undefined;

  public MAX_CART_CODES = 20;
  private scrollToTopFlag = false;

  JSON = JSON;

  constructor(
    private shortCodeService: ShortCodesService,
    protected pendOrderService: PendingOrderService,
    private accountService: AccountService,
    protected confirmationService: ConfirmationService,
    protected configService: ConfigService,
    protected router: Router,
    public routerService: RouterService,
    private scrAuthenticationService: ScrAuthenticationService
  ) {
    super();
    this.pendingOrder = new BillingOrder();
    this.pendingOrder.leases = new Array<Lease>();
    this.pendingOrder.numberOfCodes = this.pendingOrder.leases.length;
    this.pendingOrder.accountId = this.scrAuthenticationService.getAuthState()?.accountId;
    // Catch edge case of user leaving a paylater.
    this.shortCodeService.scPurchasePayLater = false;
  }

  ngOnInit() {

    const prev = this.routerService.getPreviousUrl();
    const interCartNavigation = prev && prev.includes('order-code-tab');

    this.observe(this.accountService.getAccount(), (rsp) => {
      this.account = rsp.account;
      this.monthlyBilling = rsp.account.monBillEnabled;

      // Note: I've found that history.state always exists with navigationId so the or is not necessary and deceiving.
      const incomingState = history.state as IncomingState;

      if (!interCartNavigation) {
        if (this.account.programTypeReviewStatus === ProgramTypeReviewStatus.Pending) {
          if (this.account.programTypeRequested === ProgramType.Government ||
            this.account.programTypeRequested === ProgramType.Charity ||
            (this.account.programTypeRequested === ProgramType.SMB && !incomingState.bulk && !incomingState.renew)) {
            this.displayWarningStyledAsError(new MessageCode('scr.accountpendingreview'));
          }
        }
      }


      if (incomingState.renew || incomingState.bulk) {
        // in this case, any payment info we may have saved should be cleared out.
        this.pendOrderService.removePaymentPageState();

        incomingState.order.leases.forEach(lease => { lease.selected = true; });
        this.pendingOrder = incomingState.order;
        let orderTransactionType = OrderTransactionType.Renew;

        if (incomingState.bulk) {
          orderTransactionType = OrderTransactionType.BulkRenew;
          this.bulk = incomingState.bulk;
          this.log.trace('bulk is ' + this.bulk);

          this.pendOrderService.setOrderTransactionDetails(orderTransactionType, this.pendingOrder);
        }
        else {
          this.renew = incomingState.renew;
          this.needsactionRenew = incomingState.needsactionRenew;
          this.pendingOrder.leases[0].selected = true;
          if ((this.pendingOrder.monthlyBillingEligible)) {
            this.termOptions = this.termOptionsForMB;
          }
          this.pendOrderService.setOrderTransactionDetails(orderTransactionType, this.pendingOrder); //set it to renew
          if (this.pendingOrder.leases?.length === 1 && this.pendingOrder.leases[0].term === 1) {
            this.pendingOrder.leases[0].term = 3;
            this.updatePricing({ order: this.pendingOrder, messageLocation: MessageLocation.TopOfPage, preserveExistingMessages: true });
          }
        }
        this.setLeaseColumns(this.pendingOrder, this.renew);
      }
      else {

        if (this.getOrderTransactionType() !== OrderTransactionType.New) {
          this.pendingOrder = this.pendOrderService.orderTransaction$.value.transactionOrder;
          if (this.isRenew()) {
            this.renew = true;
            this.pendingOrder.leases[0].selected = true;
            if (this.getOrderTransactionType() === OrderTransactionType.Renew1Plus12PayLater)
              this.pendingOrder.monthlyBillingEligible = true;

            if (this.pendingOrder.monthlyBillingEligible) {
              this.termOptions = this.termOptionsForMB;
              if (this.pendingOrder.choseBilledMonthly) {
                this.pendingOrder.leases[0].leaseType = LeaseType.BilledMonthly;
                this.pendingOrder.leases[0].term = 14;
              }
            }
          }
          if (this.isBulkRenew()) this.bulk = true;
          this.setLeaseColumns(this.pendingOrder, this.renew);
          // this.log.trace(this.pendingOrder);
        }
        else {
          this.configService.getConfig().subscribe(cfg => {
            const retentionFileValidTime = cfg.retentionPeriodMinutes;
            const mktbrochure = this.pendOrderService.getMarketingBrochureStorage();
            const cartValidTime = new Date().getTime() - retentionFileValidTime * 60000;
            if (!mktbrochure || mktbrochure.timestamp < cartValidTime) {
              this.log.trace(`cart retention time expired.  ${cartValidTime} ${new Date(cartValidTime)} vs brochure ${mktbrochure?.timestamp} ${mktbrochure ? new Date(mktbrochure.timestamp) : ''} `);
              this.pendOrderService.removeAllOrder(OrderTransactionType.New);
            }
            else {
              this.log.trace(' retention time valid - calling sync');
              const syncObj = this.syncCartCodes();

              this.updatePricing({
                order: syncObj.pendingOrder,
                additionalRandomCodes: syncObj.additionalRandomCodes,
                additionalSelectCodes: syncObj.additionalSelectCodes,
                validateAvailability: true,
                messageLocation: MessageLocation.CartTabSection,
                preserveExistingMessages: true,
                emitGaViewCartEvent: true
              });
            }
          });
        }
      }
      return false;
    });
  }

  makeMemorableCodeChoice(o: ShortCodeListItem, index: number): PagingInfoItem {
    const lease = new Lease();
    lease.scId = o.shortCode;
    lease.term = 3; // default term.
    lease.selectType = SelectType.Selected;
    lease.selected = true;
    lease.price = lease.term * 1000; // Set initial price before backend.
    lease.positionInItemList = index;
    const rv: PagingInfoItem = { name: `${o.shortCode}`, value: lease };
    if (o.coolName !== undefined) {
      rv.additionalName = o.coolName;
    }
    return rv;
  }

  startsWithFilter(startsWith: string) {
    this.memorableCodePaging.pageNumber = 0;
    this.observe(this.shortCodeService.getMemorableCodes(this.memorableCodeChoice || '', startsWith), rsp => {
      const options = rsp.data.shortCodeList.content.map(this.makeMemorableCodeChoice);
      this.memorableCodePaging.pageContent = chunk(options, 10);
      this.analyticsService.emitViewItems(this.memorableCodePaging.pageContent[0].map(o=>o.value), 'MemorableCode');
      this.memorableCodePaging.numberOfPages = this.memorableCodePaging.pageContent.length;
      return false;
    });
  }

  pendingOrderLeasesChanged(event: MultiStateButtonChangeEvent): void {
    // if the event's option is in the array value, this is a cart add, else remove.
    if (event.value && event.value.map(v=>v.scId).includes(event.option.value.scId)) {
      this.log.trace('cart add ' + event.option.value.scId);
      this.analyticsService.emitAddToCart(this.pendingOrder, [event.option.value.scId]);
    }
    else {
      this.log.trace('cart remove ' + event.option.value.scId);
      this.analyticsService.emitRemoveFromCart(event.option.value);
    }
  }

  setIndex(index: number | undefined) {
    this.selectedIndex = index;
  }

  coolNameRangeFilter(alphaRange: string) {

    this.memorableCodePaging.pageNumber = 0;
    this.observe(this.shortCodeService.getMemorableCodes(this.memorableCodeChoice || '', undefined, alphaRange), rsp => {
      const options = rsp.data.shortCodeList.content.map(this.makeMemorableCodeChoice);
      this.memorableCodePaging.pageContent = chunk(options, 10);
      this.analyticsService.emitViewItems(this.memorableCodePaging.pageContent[0].map(o=>o.value), 'MemorableCode');
      this.memorableCodePaging.numberOfPages = this.memorableCodePaging.pageContent.length;
      return false;
    });
  }

  memorableCodeChosen(choice?: string) {
    this.memorableCodePaging.pageNumber = 0;
    this.memorableCodePaging.numberOfPages = 0;
    this.clearAllMessages();
    this.setIndex(undefined);
    switch (choice) {
      case 'easyNumbers6':
      case 'easyNumbers5':
        this.setIndex(0);
        this.observe(this.shortCodeService.getMemorableCodes(choice, '2'), rsp => {
          const options = rsp.data.shortCodeList.content.map(this.makeMemorableCodeChoice);
          this.memorableCodePaging.pageContent = chunk(options, 10);
          this.analyticsService.emitViewItems(this.memorableCodePaging.pageContent[0].map(o=>o.value), 'MemorableCode');
          this.memorableCodePaging.numberOfPages = this.memorableCodePaging.pageContent.length;
          return false;
        });
        break;
      case 'fourIdenticalNumbers':
      case 'fourSequentialNumbers':
      case 'repeatingPairs':
      case 'coolNames':
        this.observe(this.shortCodeService.getMemorableCodes(choice), rsp => {
          const options = rsp.data.shortCodeList.content.map(this.makeMemorableCodeChoice);
          this.memorableCodePaging.pageContent = chunk(options, 10);
          this.analyticsService.emitViewItems(this.memorableCodePaging.pageContent[0].map(o=>o.value), 'MemorableCode');
          this.memorableCodePaging.numberOfPages = this.memorableCodePaging.pageContent.length;
          return false;
        });
        break;
      case 'startsAfter':
        if (this.memorableCodeRangeForm.valid) {
          this.observe(this.shortCodeService.getMemorableCodes(choice, undefined, undefined, this.shortCodeRange), rsp => {
            if (rsp.data.shortCodeList.total === 0) {
              this.memorableCodeMessage = this.translate.instant('scr.nocodematches');
            }
            else {
              const options = rsp.data.shortCodeList.content.map(this.makeMemorableCodeChoice);
              this.memorableCodePaging.pageContent = chunk(options, 10);
              this.analyticsService.emitViewItems(this.memorableCodePaging.pageContent[0].map(o=>o.value), 'MemorableCode');
              this.memorableCodePaging.numberOfPages = this.memorableCodePaging.pageContent.length;
            }
            return false;
          });
        }
        break;
      default:
        break;
    }
  }


  //Handles the case or discount and renew , no discount and renew, discount and not a renew, no discount and not a renew
  setLeaseColumns(order: BillingOrder, renew = false): void {
    let isDiscounted = order.leases.find(lease => { if (lease.discountAmount && lease.discountAmount > 0) return lease.discountAmount > 0; else return false; });
    isDiscounted = order.leases.find(lease => { if (lease.discountList && lease.discountList.length > 0) return lease.discountList.length > 0; else return false; });
    if (isDiscounted) {
      if (renew) this.tableColumn = this.tableColumnWithDiscountsRenew;
      else this.tableColumn = this.tableColumnWithDiscounts;
    } else {
      if (renew) this.tableColumn = this.tableColumnWithoutDiscountsRenew;
      else this.tableColumn = this.tableColumnWithoutDiscounts;
    }
    this.localizeTableColumns(this.tableColumn);
  }


  syncCartCodes(): SyncObj {
    const po = this.pendOrderService.getPendingOrder();
    const synObj = new SyncObj();
    const mktBrochure = this.pendOrderService.getMarketingBrochureStorage();
    synObj.pendingOrder = po;
    if (mktBrochure === undefined) {
      // nothing to synch from return the object as it was in storage
      return synObj;
    }
    // If present, read the contents
    this.log.trace(' mktBrochure = ' + JSON.stringify(mktBrochure));

    if (po.updateTime === undefined) {
      // the application's pending order should be replaced with the MB content.
      synObj.additionalSelectCodes = (mktBrochure.selectcodes ?? []).map(s => parseInt(s));
      synObj.additionalRandomCodes = mktBrochure.randomcodes;
      synObj.pendingOrder = po;
    }
    else if (po.updateTime !== undefined) {

      // There were codes in cart ?

      // Had random codes in brochure - the counts overtake application obj
      // Defaults to term 3 month and always selected.

      // Had select codes in brochure - the codes overtake application obj
      // If same codes were present in application obj - leave them as is.


      const mbSelectCodes = (mktBrochure.selectcodes ?? []).map(s => parseInt(s));
      mbSelectCodes.forEach(sc => {
        if (po.leases.some(l => l.scId === sc)) {
          // code exists in the lease.
        }
        else {
          synObj.additionalSelectCodes.push(sc);
        }
      });

      // filter out select codes that are not in the MB select list.
      po.leases = po.leases.filter(l => {
        if (l.selectType === SelectType.Random) {
          return true;
        }
        return mbSelectCodes.includes(l.scId);
      });

      if (Array.isArray(mktBrochure.randomcodes)) {
        synObj.additionalRandomCodes = [];
        // we have codes and hash - 
        // - for each see if it is present in the pending order.  if present, good, if not add to additional random codes array.
        mktBrochure.randomcodes.forEach(item => {
          const lease = po.leases.find(l => l.scId === item.code);
          if (!lease) {
            // ugh...
            (synObj.additionalRandomCodes as CodeAndHash[]).push(item);
          }
        });

        // what about randoms in the application cart that are not in the MB?
        po.leases = po.leases.filter(l => {
          if (l.selectType === SelectType.Selected) {
            return true;
          }
          return (mktBrochure.randomcodes as CodeAndHash[]).some(v => v.code === l.scId);
        });
      }
      else if (typeof mktBrochure.randomcodes === 'number') {
        // old format brochure.
        const countOfRandomLeases = po.leases.filter(l => l.selectType === SelectType.Random).length;
        if (countOfRandomLeases < mktBrochure.randomcodes) {
          synObj.additionalRandomCodes = mktBrochure.randomcodes - countOfRandomLeases;
        }
      }

      if (po.leases && po.leases.length > 0) {
        po.numberOfCodes = po.leases.length;
      }
      else {
        po.numberOfCodes = 0;
      }
    }

    this.log.trace('after processing sync-up po is (no random, no additional new codes yet)....' + JSON.stringify(po));
    this.log.trace('after processing sync-up the sync obj is (has random count, additional new codes) ....' + JSON.stringify(synObj));

    // check account ID.
    const orderAccountId = synObj.pendingOrder?.accountId;
    const authStateAccountId = this.scrAuthenticationService.getAuthState()?.accountId;
    if (orderAccountId && authStateAccountId && orderAccountId !== authStateAccountId) {
      this.log.debug(`account IDs differ: order: ${orderAccountId}, auth: ${authStateAccountId}.   Clearing cart.`);
      // cannot transfer cart from one account to another.
      synObj.additionalSelectCodes = [];
      synObj.additionalRandomCodes = 0;
      synObj.pendingOrder = new BillingOrder();

      this.pendOrderService.clear();

      // without timeout, get error about missing message component.
      setTimeout(() => {
        this.displayLocalizedWarning('scr.cartNotRetained');
        this.jumpToTop();
      }, 1000);

    }

    return synObj;
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();

    const transType = this.getOrderTransactionType();
    //Navigating back and forth internally in order tab - //Should never be empty when doing the three order tabs
    if (!this.isNewOrder()) {
      this.pendOrderService.setOrderTransactionDetails(this.getOrderTransactionType(), this.pendingOrder);
      return;
    }
    //NonNewOrders Navigates away from order tab alltogether,reset it to  new order type in parent but pendingOrder is set to empty here)
    if (this.isNewOrder() &&
      (this.pendingOrder.applicationType === ApplicationType.Renew ||
        this.pendingOrder.orderId !== null && this.pendingOrder.orderId !== undefined))
      this.pendingOrder = new BillingOrder();
    else
      if (this.pendOrderService.keepTheCode) {
        const ot = new OrderTransaction(this.pendingOrder, transType);
        this.pendOrderService.emitChangePendOrder(ot);
      } else
        this.pendingOrder = new BillingOrder();
  }

  next(): void {
    const transType = this.getOrderTransactionType();
    if (transType === OrderTransactionType.New || transType === OrderTransactionType.BulkRenew) {
      const atleastOneItemSelected = this.pendingOrder.leases.some(cartItem => cartItem.selected === true);
      if (!atleastOneItemSelected && this.pendingOrder.leases.length > 0) {
        this.clearAllMessages();
        if (transType === OrderTransactionType.New) this.displayLocalizedError('scr.cartnoneselected');
        if (transType === OrderTransactionType.BulkRenew) this.displayLocalizedError('scr.cartnoneselectedBulkRenew');
        this.jumpToTop();
      }
      else if (this.pendingOrder.leases && this.pendingOrder.leases.length < 1 && transType === OrderTransactionType.New) {
        this.clearAllMessages();
        this.displayLocalizedError('scr.cartemptyaddcode');
        this.jumpToTop();
      } else if (this.promoCode && this.promoCode.length > 0) {
        this.clearAllMessages();
        this.displayLocalizedWarning('scr.cartredeementeredcode');
        this.jumpToTop();
        return;
      } else {
        if (transType === OrderTransactionType.BulkRenew) {
          this.pendOrderService.setOrderTransactionDetails(transType, this.pendingOrder);
          this.analyticsService.emitViewBeginCheckout(this.pendingOrder)
          this.router.navigate(
            ['/dashboard',
              {
                outlets: {
                  'navbar-tab':
                    ['order-code',
                      { outlets: { 'order-code-tab': ['payment'] } }
                    ]
                }
              }
            ]);
        }
        else {
          this.pendOrderService.saveOrder(true);
          this.analyticsService.emitViewBeginCheckout(this.pendingOrder)
          this.router.navigate([
            '/dashboard',
            {
              outlets: {
                'navbar-tab': [
                  'order-code',
                  { outlets: { 'order-code-tab': ['application'] } },
                ],
              },
            },
          ]);
        }
        window.scrollTo(0, 0);
      }
    } else {
      if (this.promoCode && this.promoCode.length > 0) {
        this.clearAllMessages();
        this.displayLocalizedWarning('scr.cartredeementeredcode');
        this.jumpToTop();
        return;
      }
      this.pendOrderService.setOrderTransactionDetails(transType, this.pendingOrder);
      this.analyticsService.emitViewBeginCheckout(this.pendingOrder)
      this.router.navigate([
        '/dashboard',
        {
          outlets: {
            'navbar-tab': [
              'order-code',
              { outlets: { 'order-code-tab': ['application'] } },
            ],
          },
        },
      ], { state: { renew: true, needsactionRenew: this.needsactionRenew } });
      window.scrollTo(0, 0);
    }
  }
  cancelOrder(): void {
    if (!this.isNewOrder()) {
      this.simplyCancel();
    } else {
      this.cancelNewOrder();
    }
  }

  simplyCancel(): void {
    this.pendOrderService.leavingCheckoutPages();
    if (this.bulk || this.needsactionRenew)
      setTimeout(() => {
        this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['shortcode-needs-action'] } }] } }]);
      }, 500);
    else
      setTimeout(() => {
        this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['shortcode-list'] } }] } }]);
      }, 500);
  }

  cancelNewOrder(): void {
    this.confirmationService.confirm({
      message: `<p>Please confirm that you want to empty your cart and cancel this order.</p>`,
      header: 'Clear Order?',
      key: 'canOrder',
      accept: () => {
        this.pendOrderService.removeAllOrder(OrderTransactionType.New);
        this.clearAllMessages();
        this.clearSearchSelect();
        this.selectCodeSearch = '';
        this.randomCodesToGen = 1;
        delete this.promoCode;
        this.pendingOrder = new BillingOrder();
        this.pendOrderService.saveOrder(false);
        this.pendOrderService.leavingCheckoutPages();
        this.router.navigate([
          '/dashboard',
          {
            outlets: {
              'navbar-tab': [
                'order-code',
                { outlets: { 'order-code-tab': ['cart'] } },
              ],
            },
          },
        ]);
      }
    });
  }
  addToCart(additionalSelectCodes: number[],
    completionMessage?: string,
    completionArgs?: object,
    correspondingSearchString?: string): void {

    this.clearAllMessages();
    this.randomCodesToGen = 1;
    this.log.trace(additionalSelectCodes);

    this.updatePricing({
      order: this.pendingOrder,
      completionMessage,
      completionArgs,
      messageLocation: MessageLocation.SelectCodeSection,
      additionalRandomCodes: 0,
      additionalSelectCodes,
      correspondingSearchString,
      userInitiatedUpdate: true
    });
    if (this.shortCodeSearchForm && this.shortCodeSearchForm.valid) {
      this.shortCodeSearchForm.resetForm({ shortCodeSearch: '' });
    }
  }

  changeRandomCodesToNumber(args: ComponentUpdatePricingArgs) {
    if (Array.isArray(args.additionalRandomCodes)) {
      args.additionalRandomCodes.forEach(codes => Number(codes.code));
    }
    return args;
  }

  private updatePricing(arg: ComponentUpdatePricingArgs) {
    const args: ComponentUpdatePricingArgs = this.changeRandomCodesToNumber(arg);
    const transType = this.getOrderTransactionType();
    this.observe(this.shortCodeService.updatePricing(args), (rsp) => {
      this.pendingOrder = rsp.order;
      this.pendingOrder.numberOfCodes = rsp.order.numberOfCodes;
      this.pendingOrder.totalPrice = rsp.order.totalPrice;
      this.pendingOrder.leases = rsp.order.leases;
      this.randomCodesToGen = 1;
      const ot = new OrderTransaction(this.pendingOrder, transType);
      this.pendOrderService.emitChangePendOrder(ot);
      if (this.pendingOrder.choseBilledMonthly) this.pendingOrder.leases[0].term = 14;
      this.setLeaseColumns(this.pendingOrder, this.renew);
      this.pendOrderService.setOrderTransactionDetails(transType, this.pendingOrder);

      // if there were additions to the cart, send event.
      if (rsp.additions && rsp.additions.length > 0) {
        this.analyticsService.emitAddToCart(this.pendingOrder, rsp.additions);
      }

      if (args.emitGaEventForScId) {
        this.analyticsService.emitAddToCart(this.pendingOrder, [args.emitGaEventForScId]);
      }

      if (args.emitGaViewCartEvent) {
        this.analyticsService.emitViewCart(this.pendingOrder);
      }

      if (args.singleRedeemCodeMode && rsp.promotionsApplied && rsp.promotionsApplied.length > 0) {
        this.analyticsService.emitSelectPromotion(this.pendingOrder, rsp.promotionsApplied);
      }

      if ((rsp.codesUnavailable) && (rsp.codesUnavailable.length > 0)) {
        delete this.promoCode;

        if (!args.preserveExistingMessages) {
          this.clearAllMessages();
        }
        const codesRemovedFromCart = rsp.codesUnavailable.join(', ');
        switch (args.messageLocation) {
          case MessageLocation.TopOfPage:
            this.displayLocalizedError('scr.codelistincartunavailable', { codesRemovedFromCart });
            break;
          case MessageLocation.SelectCodeSection:
            this.selectCodeMessage = this.translate.instant('scr.codeunavailable', { codesRemovedFromCart });
            this.selectCodeMessageSeverity = 'error';
            break;
          case MessageLocation.MemorableCodeSection:
            this.memorableCodeMessage = this.translate.instant('scr.codeunavailable', { codesRemovedFromCart });
            break;
          case MessageLocation.CartTabSection:
            this.cartTabMessage = this.translate.instant('scr.codelistincartunavailable', { codesRemovedFromCart });
            break;
        }
      }
      else if ((rsp.messages || []).some(m => m.code === '4016')) {
        const m = ((rsp.messages || []).find(m => m.code === '4016'));
        if (m) {
          this.displayWarningStyledAsError(m.message);
        }
      }
      else if ((rsp.messages || []).some(m => m.code === '4015')) {
        // suppress the 4015 cart contents may have changed message if the user
        // performed an action.  It is obvious that the pricing could have changed
        // if they did something.
        const m = ((rsp.messages || []).find(m => m.code === '4015'));
        if (m && !arg.userInitiatedUpdate) {
          this.displayWarningStyledAsError(m.message);
        }
      }
      else {
        delete this.promoCode;
        if (!args.preserveExistingMessages) {
          this.clearAllMessages();
        }
        if (rsp.messages && rsp.messages.length > 0 && rsp.messages[0].code !== '2100') {
          // display messages.
          this.processMessages(rsp);
        }
        if (args.completionMessage) {

          if (args.completionMessage === 'scr.accountpendingreview') {
            this.displayLocalizedWarning('scr.accountpendingreview');
          }
          else if (args.completionMessage === 'scr.renew1plus12warning') {
            this.displayLocalizedWarning('scr.renew1plus12warning');
          }
          else {
            switch (args.messageLocation) {
              case MessageLocation.TopOfPage:
                this.displayLocalizedError(args.completionMessage, args.completionArgs);
                break;
              case MessageLocation.SelectCodeSection:
                this.selectCodeMessage = this.translate.instant(args.completionMessage, args.completionArgs);
                this.selectCodeMessageSeverity = 'error';
                break;
              case MessageLocation.MemorableCodeSection:
                this.memorableCodeMessage = this.translate.instant(args.completionMessage, args.completionArgs);
                break;
              case MessageLocation.CartTabSection:
                this.cartTabMessage = this.translate.instant(args.completionMessage, args.completionArgs);
                break;
            }
          }
        }
        if (this.isBulkRenew() && args.singleRedeemCodeMode) {
          this.displaySuccessMessage('Success', 'If you choose the Pay Later option on the Payment tab, any applied promotions will be finalized when you submit your order, and will be reflected on your invoices. If you choose the Pay Now option, any applied promotions will be applied as shown.', 0);
        }
      }

      if (this.scrollToTopFlag) {
        window.scrollTo(0, 0);
        this.scrollToTopFlag = false;
      }

      return false;
    });
  }


  addRandom(additionalRandomCodes: number) {
    if (this.pendingOrder.leases.length >= this.MAX_CART_CODES) {
      this.clearAllMessages();
      this.randomCodeMessage = this.translate.instant("scr.cartfull");
      return;
    }
    if (additionalRandomCodes > 0) {
      this.clearAllMessages();
      this.updatePricing({ order: this.pendingOrder, additionalRandomCodes, userInitiatedUpdate:true });
    }
  }

  addSelect(userInputShortCode: string): void {
    this.clearAllMessages();
    if (this.pendingOrder.leases.length < this.MAX_CART_CODES) {
      this.observe(this.shortCodeService.getSelectCode(userInputShortCode), rsp => {
        const codeAsInt = Number(userInputShortCode);
        const isDuplicate = this.pendingOrder.leases.some(lease => lease.scId === codeAsInt);
        if (isDuplicate) {
          this.selectCodeMessage = this.translate.instant('scr.codealreadyincart', { userInputShortCode });
          this.selectCodeMessageSeverity = 'error';
        }
        else if (rsp.data.results && rsp.data.results.length == 0) {
          const codesRemovedFromCart = userInputShortCode;
          this.selectCodeMessage = this.translate.instant('scr.codeunavailable', { codesRemovedFromCart });
          this.selectCodeMessageSeverity = 'error';
        }
        else {
          this.clearSearchSelect(false);
          const isAlphaNumericSearch = /[a-zA-Z]/.test(userInputShortCode);
          if (isAlphaNumericSearch) {
            this.addToCart(rsp.data.results, 'scr.codeaddedtocart', { userInputShortCode }, userInputShortCode);
          }
          else {
            this.addToCart(rsp.data.results, 'scr.codeaddedtocart', { userInputShortCode });
          }
        }

        return false;
      });
    } else {
      this.clearAllMessages();
      this.selectCodeMessage = this.translate.instant('scr.cartfull');
      this.selectCodeMessageSeverity = 'error';
    }
  }

  searchSelect(userInputShortCode: string, codeSearchForm: NgForm): void {
    this.clearAllMessages();
    this.resetOptions();
    if (codeSearchForm.valid) {
      this.selectSearched = true;
      this.observe(this.shortCodeService.getSelectCode(userInputShortCode), rsp => {
        const isWildCardSearch = userInputShortCode.includes('*');
        if (isWildCardSearch) {
          const options = rsp.data.results.map((code, index) => {
            const lease = new Lease();
            lease.positionInItemList = index;
            lease.scId = code;
            lease.term = 3; // default term.
            lease.selectType = SelectType.Selected;
            lease.selected = true;
            lease.price = lease.term * 1000; // Set initial price before backend.
            return { name: `${code}`, value: lease };
          });
          this.wildCardPaging.pageContent = chunk(options, 6);
          if (this.wildCardPaging.pageContent[0]) {
            this.analyticsService.emitViewItems(this.wildCardPaging.pageContent[0].map(o=>o.value), 'WildcardSearch');
          }
          this.wildCardPaging.numberOfPages = this.wildCardPaging.pageContent.length;
        } else {
          if (rsp.data.similar.length > this.NUM_OF_SIMILARS_TO_RETURN) {
            const randomResults = this.getRandom(rsp.data.similar, this.NUM_OF_SIMILARS_TO_RETURN);

            randomResults.sort().forEach((code) => {
              const lease = new Lease();
              lease.scId = code;
              lease.term = 3; // default term.
              lease.selectType = SelectType.Selected;
              lease.selected = true;
              lease.price = lease.term * 1000; // Set initial price before backend.
              this.similarCodeOptions.push({ name: `${code}`, value: lease });
            });
          } else {
            rsp.data.similar.forEach((code) => {
              const lease = new Lease();
              lease.scId = code;
              lease.term = 3; // default term.
              lease.selectType = SelectType.Selected;
              lease.selected = true;
              lease.price = lease.term * 1000; // Set initial price before backend.
              this.similarCodeOptions.push({ name: `${code}`, value: lease });
            });
          }
          if (this.similarCodeOptions) {
            this.analyticsService.emitViewItems(this.similarCodeOptions.map(o=>o.value), 'Search');
          }
        }

        if (rsp.data.results.length > 0) {
          this.codeAvailable = true;
          if (!isWildCardSearch) {
            this.selectCodeMessage = this.translate.instant('scr.codeavailable', { userInputShortCode });
            this.selectCodeMessageSeverity = 'success';
          } else {
            const resultCount = rsp.data.results.length;
            this.selectCodeMessage = this.translate.instant('scr.wildcardsuccess', { resultCount });
            this.selectCodeMessageSeverity = 'success';
          }
        } else {
          this.codeAvailable = false;
          if (userInputShortCode.includes('*')) {
            this.selectCodeMessage = this.translate.instant('scr.wildcardcodeunavailable', { userInputShortCode });
            this.selectCodeMessageSeverity = 'error';
          } else {
            const codesRemovedFromCart = userInputShortCode;
            this.selectCodeMessage = this.translate.instant('scr.codeunavailable', { codesRemovedFromCart });
            this.selectCodeMessageSeverity = 'error';
          }
        }
        return false;
      });
    }
    else {
      this.scrollToFirstError();
    }
  }

  pageUp(pageableObject: PagingInfo) {
    pageableObject.pageNumber = pageableObject.pageNumber + 1;
    this.analyticsService.emitViewItems(pageableObject.pageContent[pageableObject.pageNumber].map(o=>o.value), pageableObject.location);
  }

  pageDown(pageableObject: PagingInfo) {
    pageableObject.pageNumber = pageableObject.pageNumber - 1;
    this.analyticsService.emitViewItems(pageableObject.pageContent[pageableObject.pageNumber].map(o=>o.value), pageableObject.location);
  }

  resetOptions() {
    this.similarCodeOptions = [];
    this.randomCodesToGen = 1;
    this.resetPaging();
  }

  resetPaging() {
    this.wildCardPaging = {
      location: "Wildcard",
      pageNumber: 0,
      numberOfPages: 0,
      pageContent: []
    };
  }

  clearSearchSelect(clearSimilar = true, repopulate = true): void {

    if (clearSimilar) {
      this.similarCodeOptions = [];
    }
    this.selectCodeSearch = '';
    this.memorableCodeChoice = '';
    this.memorableCodePaging.numberOfPages = 0;
    this.codeAvailable = false;
    this.selectSearched = false;
    this.resetPaging();
    if (this.shortCodeSearchForm.valid && repopulate) {
      this.shortCodeSearchForm.resetForm(this.shortCodeSearchForm.value);
    } else {
      this.shortCodeSearchForm.resetForm({ shortCodeSearch: '' });
      this.clearAllMessages();
    }
  }

  selectCodeOnChange() {
    if (this.selectSearched) {
      this.codeAvailable = false;
      this.selectSearched = false;
      this.clearAllMessages();
    }
  }

  removeFromCart(codeToRemove: number): void {
    this.clearAllMessages();
    if (this.getOrderTransactionType() === OrderTransactionType.BulkRenew && this.pendingOrder.leases.length === 1) {
      this.displayLocalizedWarning('scr.cartemptybulkrenew');
      this.jumpToTop();
      return;
    }
    const itemToRemove = this.pendingOrder.leases.find(l=> l.scId === codeToRemove);
    if (itemToRemove) {
      this.analyticsService.emitRemoveFromCart(itemToRemove);
    }

    this.pendingOrder.leases = this.pendingOrder.leases.filter(l => !(l.scId === codeToRemove));
    this.pendingOrder.numberOfCodes = this.pendingOrder.leases.length;
    const shortCodesData = localStorage.getItem('ngStorage-scr_codes');
    if (shortCodesData) {
      const parsedShortCodesData = this.JSON.parse(shortCodesData);
      const randomCodes = parsedShortCodesData.randomcodes;
      if (Number(parsedShortCodesData.version) === 2) {
        const filteredShortCodesData = randomCodes?.filter((codes: HashCode) => {
          return Number(codes.code) !== codeToRemove;
        });
        const dataAfterRemove = Object.assign({}, parsedShortCodesData, { randomcodes: filteredShortCodesData });
        localStorage.setItem('ngStorage-scr_codes', this.JSON.stringify(dataAfterRemove));
      }
    }
    this.updatePricing({ order: this.pendingOrder, leaseByLeaseMode: this.bulk, userInitiatedUpdate:true });
  }

  calculateCodePrice(row?: Lease): void {
    let emitGaEventForScId: number | undefined;

    if (row) {
      emitGaEventForScId = row.scId
    }
    
    if (this.isRenew()) {
      if (this.pendingOrder.monthlyBillingEligible && (this.pendingOrder.leases[0].term == 14)) {
        this.pendingOrder.choseBilledMonthly = true;
        this.pendingOrder.leases[0].term = 12;
        this.pendingOrder.leases[0].leaseType = LeaseType.BilledMonthly;
        const orderTransactionType = this.pendingOrder.monthlyBillingEligible && this.pendingOrder.renew1Plus12 ? OrderTransactionType.Renew1Plus12
          : OrderTransactionType.EnrollInMonthlyBilling;

        this.pendOrderService.setOrderTransactionDetails(orderTransactionType, this.pendingOrder);
      }
      else {
        this.pendingOrder.enrollInMonthlyBilling = false;
        this.pendingOrder.choseBilledMonthly = false;
        this.pendingOrder.leases[0].leaseType = LeaseType.Prepay;
        this.pendingOrder.leases[0].addToMb = false;
        if (this.pendingOrder.leases.length > 1 && this.pendingOrder.leases[0].scId === this.pendingOrder.leases[1].scId) {
          this.pendingOrder.leases.pop();
        }
        this.pendOrderService.setOrderTransactionDetails(OrderTransactionType.Renew, this.pendingOrder);
      }
    }

    if (this.pendingOrder.choseBilledMonthly && this.getOrderTransactionType() === OrderTransactionType.Renew1Plus12) {
      this.updatePricing({ order: this.pendingOrder, completionMessage: 'scr.renew1plus12warning', addOneMonthLease: this.pendingOrder.choseBilledMonthly, leaseByLeaseMode: this.bulk, userInitiatedUpdate:true, emitGaEventForScId });
    }
    else {
      this.updatePricing({ order: this.pendingOrder, leaseByLeaseMode: this.bulk, userInitiatedUpdate:true, emitGaEventForScId });
    }
  }

  multiButtonChange(codeForm: NgForm) {
    this.clearAllMessages();
    if (this.pendingOrder.leases.length !== this.MAX_CART_CODES) {
      this.calculateCodePrice();
      this.randomCodesToGen = 1;
    } else {
      this.clearAllMessages();
      if (codeForm === this.shortCodeSearchForm) {
        this.selectCodeMessage = this.translate.instant('scr.cartfull');
        this.selectCodeMessageSeverity = 'error';
      }
      else if (codeForm === this.memorableCodeRangeForm) {
        this.memorableCodeMessage = this.translate.instant('scr.cartfull');
      }
    }
  }


  getRandom(arr: number[], n: number) {
    const result = new Array(n);
    let len = arr.length;
    const taken = new Array(len);
    if (n > len)
      throw new RangeError("getRandom: more elements taken than available");
    while (n--) {
      const x = Math.floor(Math.random() * len);
      result[n] = arr[x in taken ? taken[x] : x];
      taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
  }

  /**
   * Clears both IUI and local messages.
   */
  clearAllMessages() {
    this.clearMessages();
    delete this.selectCodeMessage;
    delete this.memorableCodeMessage;
    delete this.cartTabMessage;
    delete this.randomCodeMessage;
  }



  /**
   * User has pressed the redeem button to apply a promotion to the order.
   */
  redeemPromo(): void {
    this.log.debug('redeem promo ' + this.promoCode);
    this.clearMessages();
    if (this.pendingOrder.leases.filter(l => l.selected).length <= 0) {
      this.displayLocalizedError('scr.cartnocodes');
      this.jumpToTop();
      return;
    }
    this.scrollToTopFlag = true;
    if (this.getOrderTransactionType() === OrderTransactionType.EnrollInMonthlyBilling ||
      this.getOrderTransactionType() === OrderTransactionType.Renew1Plus12) {
      this.pendingOrder.leases[0].term = 12;
    }
    if (!this.promoCode) {
      return;
    }
    this.updatePricing({
      order: this.pendingOrder,
      messageLocation: MessageLocation.TopOfPage,
      applyPromotionCode: this.promoCode,
      singleRedeemCodeMode: true,
      userInitiatedUpdate:true
    });
  }


  hasRedeemedDiscounts(order: BillingOrder): boolean {
    for (const lease of order.leases) {
      if (lease.discountList) {
        if (lease.discountList.some(d => !d.autoApply)) {
          return true;
        }
      }
    }
    return false;
  }

  getRedeemedDiscounts(order: BillingOrder): DiscountSummary[] {
    const rv: DiscountSummary[] = [];
    for (const lease of order.leases) {
      if (lease.discountList) {
        lease.discountList.filter(d => {
          return !d.autoApply && !rv.some(rvd => rvd.discountId === d.discountId);
        }).forEach(d => {
          rv.push(d);
        });
      }
    }
    return rv;
  }

  getDiscountList(lease: Lease) {
    if (!lease.discountList || lease.discountList.length === 0) {
      return '';
    }
    else {
      return lease.discountList.map(disc => disc.displayName).join(', ');
    }
  }

  removePromo(p: DiscountSummary) {
    if (this.getOrderTransactionType() === OrderTransactionType.EnrollInMonthlyBilling ||
      this.getOrderTransactionType() === OrderTransactionType.Renew1Plus12) {
      this.pendingOrder.leases[0].term = 12;
    }
    this.updatePricing({ order: this.pendingOrder, leaseByLeaseMode: this.bulk, removePromotionCode: p.redeemCode, userInitiatedUpdate:true });
  }


  getOrderTransactionType(): OrderTransactionType {
    return this.pendOrderService.orderTransaction$.value.transactionType;
  }

  isPayLater(): boolean {
    const saveType = this.getOrderTransactionType();

    const plFlag = saveType === OrderTransactionType.NewPayLater ||
      saveType === OrderTransactionType.RenewPayLater ||
      saveType === OrderTransactionType.Renew1Plus12PayLater ||
      saveType === OrderTransactionType.Renew1Plus12AfterDeadline;

    return plFlag;
  }

  isManualPay(): boolean {
    const saveType = this.getOrderTransactionType();
    const manualPay = saveType === OrderTransactionType.ManualPayMonthlyBilling;
    return manualPay;
  }

  isRenew(): boolean {
    const saveType = this.getOrderTransactionType();

    const renew = saveType === OrderTransactionType.Renew ||
      saveType === OrderTransactionType.RenewPayLater ||
      saveType === OrderTransactionType.Renew1Plus12PayLater ||
      saveType === OrderTransactionType.EnrollInMonthlyBilling ||
      saveType === OrderTransactionType.Renew1Plus12 ||
      saveType === OrderTransactionType.Renew1Plus12AfterDeadline;
    return renew;
  }

  isBulkRenew(): boolean {
    const saveType = this.getOrderTransactionType();
    return saveType === OrderTransactionType.BulkRenew;
  }

  isRenew1Plus12(): boolean {
    const saveType = this.getOrderTransactionType();
    const renew1plus12 =
      saveType === OrderTransactionType.Renew1Plus12PayLater ||
      saveType === OrderTransactionType.Renew1Plus12;
    return renew1plus12;
  }

  ifRenew1Plus12DeadlinePassed(): boolean {
    const saveType = this.getOrderTransactionType();
    const deadlinePassed =
      saveType === OrderTransactionType.Renew1Plus12AfterDeadline;

    return deadlinePassed;
  }

  isNewOrder(): boolean {
    const transType = this.getOrderTransactionType();
    return transType === OrderTransactionType.New;
  }

}